import axiosInstance from "../axiosInstance";
import { apiEndpoints } from "../apiConfig";

const openPositionsApi = {
    addNewPosition: (payload) => axiosInstance.post(apiEndpoints.addNewPosition, payload),
    updatePosition: (payload) => axiosInstance.post(apiEndpoints.updatePosition, payload),
    getAllPositions: () => axiosInstance.get(apiEndpoints.getAllPositions),
};

export default openPositionsApi;